import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import LandingPage from "pages/landing-page";
import LoginPage from "pages/login";
import ProfilePage from "pages/profile";
import NotFound from "pages/NotFound";
import AdminDashboardPage from "pages/admin/dashboard";
import AdminLoginPage from "pages/admin";
import AdminProtectedRoute from "components/AdminProtectedRoute";
import WriterDashboardPage from "pages/writer/dashboard";
import QADashboardPage from "pages/qa/dashboard";
import ClientDashboardPage from "pages/client/dashboard";
import WriterProtectedRoute from "components/WriterProtectedRoute";
import QAProtectedRoute from "components/QAProtectedRoute";
import ClientProtectedRoute from "components/ClientProtectedRoute";
import BlogPage from "pages/BlogPage";
import CreateBlog from "pages/admin/CreateBlog";
import { AuthProvider } from "contexts/AuthContext";
import { TourProvider } from "contexts/TourContext";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <AuthProvider>
          <TourProvider>
            <RouterRoutes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
            <Route path="/writer/dashboard" element={<WriterProtectedRoute><WriterDashboardPage /></WriterProtectedRoute>} />
            <Route path="/qa/dashboard" element={<QAProtectedRoute><QADashboardPage /></QAProtectedRoute>} />
            <Route path="/client/dashboard" element={<ClientProtectedRoute><ClientDashboardPage /></ClientProtectedRoute>} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/admin/blog/create" element={<AdminProtectedRoute><CreateBlog /></AdminProtectedRoute>} />
            </RouterRoutes>
          </TourProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
